export default {
  namespaced: true,

  state: {
    items: []
  },

  mutations: {
    retrieve(state) {
      window.Ajax.get('/vehicle-types')
        .then(response => {
          state.items = response.data;
        })
        .catch(err => {});
    }
  },
  getters: {
    all(state) {
      return state.items;
    }
  }
};
